export default "/images/120f81b8de13cb5692ef1041bcc3ffed.avif";